import React from 'react';
import classNames from 'classnames/bind';
import styles from './moreFeedback.module.scss';

const feedBackUrl =
  'https://docs.google.com/forms/d/1sK-sg_nGN9tL-cx-9Hg2xRzBFEJJr7TmwQQn9STSZqM/viewform?edit_requested=true';

const cx = classNames.bind(styles);

const MoreFeedback = () => {
  return (
    <div className={cx('moreFeedbackArea')}>
      <em className={cx('title')}>
        추가적으로 궁금하신 사항이나
        <br />
        필요한 점이 있으면 의견 남겨주세요.
      </em>
      <button className={cx('submitButton')} onClick={() => window.open(feedBackUrl)}>
        추가 의견 작성하기
      </button>
    </div>
  );
};

export default MoreFeedback;
